const API_BASE = "/api/v1"

export interface ShareCardResponse {
  token: string
  share_url: string
  share_path: string
  og_image_url: string
}

export async function createShareCard(aspectRatio: "vertical" | "square"): Promise<ShareCardResponse> {
  const response = await fetch(`${API_BASE}/share_cards`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ aspect_ratio: aspectRatio }),
  })

  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const message = Array.isArray(data.errors) ? data.errors[0] : "Could not create share link"
    throw new Error(message)
  }
  return data as ShareCardResponse
}
